import React from 'react'
import { TableCard } from '@/components/shared/table-card'
import { Order } from '@/types/order'
import { formatDate, calculateOrderVolume } from '@/utils/orderUtils'
import { EditableOrderStatus } from './EditableOrderStatus'
import { EditableExternalOrderCode } from './EditableExternalOrderCode'
import { EditableOrderCode } from './EditableOrderCode'
import { EditableOrderNumber } from './EditableOrderNumber'

interface OrderDetailsCardProps {
  order: Order
  className?: string
}

export const OrderDetailsCard: React.FC<OrderDetailsCardProps> = ({
  order,
  className,
}) => {
  const detailsData = [
    { label: 'ID', value: order.id },
    {
      label: 'Status',
      value: (
        <EditableOrderStatus
          orderId={order.id}
          currentStatus={order.order_status}
        />
      ),
    },
    { label: 'Order Type', value: order.order_type || '-' },
    {
      label: 'Order Number',
      value: (
        <EditableOrderNumber
          orderId={order.id}
          currentValue={order.order_number}
        />
      ),
    },
    {
      label: 'Order Code',
      value: (
        <EditableOrderCode
          orderId={order.id}
          currentValue={order.order_code}
        />
      ),
    },
    {
      label: 'External Order Code',
      value: (
        <EditableExternalOrderCode
          orderId={order.id}
          currentValue={order.order_external_code}
        />
      ),
    },
    { label: 'Invoice Code', value: order.invoice_code || '-' },
    {
      label: 'Preferred Delivery',
      value: order.preferred_delivery_date
        ? formatDate(order.preferred_delivery_date)
        : '-',
    },
    {
      label: 'Confirmed Delivery',
      value: order.confirmed_delivery_date
        ? formatDate(order.confirmed_delivery_date)
        : '-',
    },

    { label: 'Created at', value: formatDate(order.createdAt, true) },
    { label: 'Updated at', value: formatDate(order.updatedAt, true) },
    { label: 'Locale', value: order.order_locale || '-' },
  ]

  return <TableCard title="Details" data={detailsData} className={className} />
}
